export default __webpack_public_path__ + "static/media/Ellipse 35.05845f28.svg";